import React, {Component} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCrosshairs, faInfoCircle} from "@fortawesome/free-solid-svg-icons";
import {
    testCustomNodeProvider,
    getWalletBalance, getBotTokenBalance, getAccount
} from '../utils/walletConfig';
import {
    snipeToken,
    getTokenInfo,
    getLiquidity,
    approveTokensForSell,
    isTradingStillDisabled
} from "../utils/Transactions";
import Cookies from 'universal-cookie';
import {
    handleSlippageInfo,
    handleMaxGasInfo,
    handleGweiInfo,
    handleAutoSnipe,
    handleNodeInfo,
    handleFrontRunInfo,
    handleHoneypotCheckedInfo,
    handleBlockDelayInfo,
    handleAbiMethodInfo
} from '../utils/infoIcons'
import DisplayData from "./DisplayData";
import {BINANCE_PROVIDER_URL, bsc, getProviderUrl, getReasonForFailure, uniswap, UNISWAP_PROVIDER_URL} from "../const";
import {
    extractContractAddress,
    getSymbolFromChain,
    isHoneypot,
    parseAbi,
    removeCommas,
    verifyBscApiKey
} from "../utils";
import {clearIntervalAsync, setIntervalAsync} from 'set-interval-async/dynamic'

class SniperForm extends Component {
    constructor(props) {
        super(props);
        const cookies = new Cookies();
        const customConfigValues = {
            bnbAmountToSnipe: '0.01',
            buyTimes: '1',
            slippage: '49',
            maxGas: '1000000',
            gwei: '35',
            autoSnipe: false,
            frontrun: false,
            checkForHoneypot: false,
        }
        if (!cookies.get('custom_configuration')) {
            cookies.set('custom_configuration', customConfigValues, {path: '/'})
        }
        const customConfig = cookies.get('custom_configuration');
        this.state = {
            tokenAddress: '',
            maxGas: customConfig.maxGas || '1000000',
            gwei: customConfig.gwei || '35',
            bnbAmountToSnipe: customConfig.bnbAmountToSnipe || '0.01',
            slippage: customConfig.slippage || '49',
            isLoading: false,
            targetToken: '',
            canSubmit: false,
            pk: '',
            reasonForFailure: null,
            botTokenBalance: '',
            tokenInfo: {},
            selectedOption: 'buy',
            incorrectCA: false,
            selectedSellOption: '100',
            autoSnipe: customConfig.autoSnipe || false,
            customNodeUrl: '',
            frontRun: false,
            defaultProvider: 'https://bsc-dataseed1.ninicoin.io/',
            chains: [bsc, uniswap],
            selectedChain: bsc,
            walletBalance: '0',
            buyTimes: customConfig.buyTimes || '1',
            showSnipeSuccess: false,
            successAmt: 0,
            failAmt: 0,
            selectedToken: 'bnb',
            tokenOptions: ['bnb', 'busd'],
            checkForHoneypot: customConfig.checkForHoneypot || false,
            tokenIsHoneypot: false,
            sellTimes: '1',
            blockDelay: '0',
            tradingDisabled: false,
            methodSignature: '',
            abiFunctions: [],
            selectedAbiFunction: '',
        }
    }

    async componentDidMount() {
        const cookies = new Cookies();
        const pk = cookies.get('asb_pk');
        if (!pk) {
            window.location = '/contact'
        }
        let botTokenBalance;
        try {
            botTokenBalance = await getBotTokenBalance('0x3a2b0d89b7a810b35f3cab73d1f66e87194a6bc1', pk)
        } catch (e) {
            console.log("error getting balance: ", e);
            throw new Error('Error occured fetching bot token balance');
        }
        if (botTokenBalance >= 1) {
            this.setState({
                botTokenBalance,
                pk
            })
        } else {
            window.location = '/contact'
        }
        const {selectedChain} = this.state;
        let walletBalance;
        try {
            walletBalance = await getWalletBalance(selectedChain)
            this.setState({
                walletBalance,
            })
        } catch (e) {
        }
    }

    async componentDidUpdate(prevProps, prevState) {
        const {selectedChain} = this.state;
        let walletBalance;
        if (selectedChain !== prevState.selectedChain) {
            try {
                walletBalance = await getWalletBalance(selectedChain)
                this.setState({
                    walletBalance,
                })

            } catch (e) {
            }
        }
    }

    handleOnchange = async (e) => {
        const {autoSnipe, selectedOption, frontRun} = this.state;
        if (this.liquidityInterval) clearIntervalAsync(this.liquidityInterval);
        if (frontRun) {
            this.setState({
                frontRun: !frontRun,
                isLoading: false,
            })
        }
        let {name, value} = e.target;
        if (name === 'maxGas' && value !== '') {
            value = removeCommas(value)
        }
        if (name === 'tokenAddress') {
            if (this.coinInterval) clearIntervalAsync(this.coinInterval)
            let extractedValue = extractContractAddress(value)
            if (extractedValue.length !== 42) {
                this.setState({
                    incorrectCa: true,
                })
            } else {
                value = extractedValue;
                this.setState({
                    incorrectCa: false,
                })
            }
        }
        this.setState({
            [name]: value,
        }, async () => {
            const {tokenAddress, incorrectCa} = this.state;
            if (name === 'tokenAddress' && tokenAddress !== '' && incorrectCa === false && autoSnipe && selectedOption === 'buy') {
                await this.handleSubmit()
            }
        })
        if (name === 'tokenAddress' && value.length === 42) {
            if (this.coinInterval) clearIntervalAsync(this.coinInterval)
            await this.getTokenInformation(value)
        }
    }

    getTokenInformation = async (tokenAddress) => {
        if (this.coinInterval) clearIntervalAsync(this.coinInterval)
        const {selectedChain} = this.state;
        let tokenInfo = {};
        try {
            tokenInfo = await getTokenInfo(tokenAddress, selectedChain);
            this.setState({
                tokenInfo,
                incorrectCa: false
            })
        } catch (e) {
            console.log("error getting token info: ", e)
        }
        if (tokenInfo) {
            this.coinInterval = setIntervalAsync(
                async () => {
                    try {
                        tokenInfo = await getTokenInfo(tokenAddress, selectedChain);
                        this.setState({
                            tokenInfo,
                            incorrectCa: false
                        })
                    } catch (e) {
                        console.log("error getting tokeninfo inside interval: ", e)
                    }
                }, 3000)
        }
    }

    checkLiquidity = async () => {
        const {tokenAddress, selectedChain, selectedToken} = this.state;
        let liquidity;
        liquidity = await getLiquidity(tokenAddress, selectedChain, this.liquidityInterval, selectedToken);
        if (liquidity !== '0.0' && Number(liquidity) > 0.0) {
            clearIntervalAsync(this.liquidityInterval);
        }
        return liquidity;
    }

    handleTransaction = async () => {
        if (this.liquidityInterval) clearIntervalAsync(this.liquidityInterval);
        // if(this.tradingDisabledInterval) clearIntervalAsync(this.tradingDisabledInterval);
        const {
            selectedOption,
            tokenAddress,
            selectedChain,
            defaultProvider
        } = this.state;
        let {successAmt, failAmt} = this.state;
        try {
            const txnStatus = await snipeToken(this.state);
            const {reason, status, receipts} = txnStatus;
            if (receipts && receipts.length > 0) {
                receipts.forEach(receipt => {
                    if (receipt.status === 'success') successAmt++;
                    if (receipt.status === 'fail') {
                        failAmt++;

                    }
                })
            }
            if (successAmt > 0) {
                if (selectedOption === 'buy') {
                    try {
                        this.setState({
                            isLoading: false,
                            showSnipeSuccess: true,
                            successAmt,
                            failAmt,
                            blockDelay: '0',
                            tradingDisabled: false,
                        })
                        await approveTokensForSell(tokenAddress, selectedChain, defaultProvider);
                        setTimeout(() => {
                            this.setState({
                                showSnipeSuccess: false,
                                successAmt: 0,
                                failAmt: 0,
                                tradingDisabled: false,
                            })
                        }, 3000)
                    } catch (e) {
                    }
                } else alert('Successfully Sold Tokens.')
            }
            if (reason && status) {
                let reasonForFailure = getReasonForFailure(status, reason);
                this.setState({
                    snipe: status,
                    receipts,
                    reasonForFailure,
                    isLoading: false,
                    frontRun: false,
                    autoSnipe: false,
                    tradingDisabled: false,
                })
                setTimeout(() => {
                    this.setState({
                        snipe: '',
                        reasonForFailure: '',
                    })
                }, 5000)
            }
            if (status === 'fail' || failAmt > 0) {
                this.setState({
                    snipe: status,
                    receipts,
                    failAmt,
                    isLoading: false,
                    frontRun: false,
                    autoSnipe: false,
                    tradingDisabled: false,
                })
                setTimeout(() => {
                    this.setState({
                        snipe: '',
                        successAmt: 0,
                        failAmt: 0,
                    })
                }, 5000)
            }
        } catch (e) {
            alert('An error occured, please try again or contact the dev.')
            this.setState({
                isLoading: false,
                frontRun: false,
                autoSnipe: false,
            })
        }
    }

    handleSubmit = async (e) => {
        const {frontRun, selectedAbiFunction, tradingDisabled, tokenAddress, checkForHoneypot, selectedChain} = this.state;
        if (checkForHoneypot) {
            const isTokenHoneypot = await isHoneypot(tokenAddress);
            if (isTokenHoneypot) {
                this.setState({
                    tokenIsHoneypot: true,
                })
                setTimeout(() => {
                    this.setState({
                        tokenIsHoneypot: false,
                    })
                }, 5000)
                return;
            }
        }
        this.setState({
            isLoading: true
        })
        if (frontRun) {
            this.liquidityInterval = setIntervalAsync(
                async () => await this.liquidityCallBackFn(), 1000
            )
        } else if (tradingDisabled) {
            if(!selectedAbiFunction || selectedAbiFunction === 'Select A Method'){
                alert('You need to select a method to track, otherwise please select No');
                this.setState({
                    isLoading: false
                })
                return;
            }
            const cookies = new Cookies();
            const apikey = cookies.get('bsc_api');
            if (!cookies.get('bsc_api')) {
                alert('You need to add a bscscan api key to use this feature.\nPlease contact the developer for more info.');
                return;
            }
            this.tradingDisabledInterval = setIntervalAsync(
                async () => await this.tradingDisabledCallBackFn(apikey, selectedAbiFunction, tokenAddress, selectedChain), 250
            )
        } else {
            await this.handleTransaction(this.state);
        }
    }

    tradingDisabledCallBackFn = async(apikey, selectedAbiFunction, tokenAddress, selectedChain) => {
        let tradingStillDisabled = await isTradingStillDisabled(apikey, selectedAbiFunction, tokenAddress, selectedChain);
        if (tradingStillDisabled === false) {
            clearIntervalAsync(this.tradingDisabledInterval);
            await this.handleTransaction(this.state);
            return;
        }
    }

    liquidityCallBackFn = async () => {
        const liquidity = await this.checkLiquidity();
        if (liquidity !== '0.0' && Number(liquidity) > 0.0) {
            clearIntervalAsync(this.liquidityInterval);
            this.setState({frontRun: false, liquidity})
            await this.handleTransaction(this.state);
            return;
        }
        ;
    }

    onChangeValue = (e) => {
        const {value} = e.target;
        if (value === 'sell') {
            this.setState({
                selectedOption: value,
                autoSnipe: false,
                frontRun: false,
                checkForHoneypot: false,
                tradingDisabled: false,
            })
        } else if (value === 'buy') {
            this.setState({
                selectedOption: value,
            })
        } else {
            this.setState({
                selectedSellOption: value
            })
        }
    }

    handleCheckboxChange = (e) => {
        const {autoSnipe} = this.state;
        this.setState({
            autoSnipe: !autoSnipe,
        })
    }

    handleAddNode = async (e) => {
        e.preventDefault();
        const {selectedChain} = this.state;
        const defaultNodeProvider = getProviderUrl(selectedChain);
        const cookies = new Cookies();
        let fiveYearsFromNow = new Date();
        fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
        if (!cookies.get('custom_nodes')) {
            cookies.set('custom_nodes', [], {path: '/', expires: fiveYearsFromNow})
        }
        const nodes = cookies.get('custom_nodes')
        const value = prompt("Enter your custom node url")
        if (!value) {
            return;
        }
        if (await testCustomNodeProvider(selectedChain, value)) {
            nodes.push(value)
            cookies.set('custom_nodes', nodes, {path: '/', expires: fiveYearsFromNow})
            alert('Node has been added successfully.')
        } else {
            alert('Invalid Node Url.')
        }
        this.setState({
            defaultProvider: value || defaultNodeProvider,
        })
    }

    handleNodeChange = async (e) => {
        e.preventDefault();
        const {value} = e.target;
        const {selectedChain} = this.state;
        const resetProvider = selectedChain === bsc ? BINANCE_PROVIDER_URL : UNISWAP_PROVIDER_URL;
        const isValidProvider = await testCustomNodeProvider(selectedChain, value);
        if (!isValidProvider) {
            alert('This node is not compatible with the ' + selectedChain + ' network')
            this.setState({
                defaultProvider: resetProvider
            })
        } else {
            this.setState({
                defaultProvider: value
            })
        }
    }

    handleFrontRun = (e) => {
        const {frontRun} = this.state;
        this.setState({
            frontRun: !frontRun,
        })
    }

    handleRemoveNode = (e) => {
        e.preventDefault();
        const {defaultProvider} = this.state;
        const cookies = new Cookies();
        const customNodes = cookies.get('custom_nodes');
        let fiveYearsFromNow = new Date();
        fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
        let nodeIndexToDelete = '';
        customNodes.forEach((customNode, idx) => {
            if (customNode === defaultProvider) {
                nodeIndexToDelete = idx;
            }
        })
        if (nodeIndexToDelete > -1) {
            customNodes.splice(nodeIndexToDelete, 1);
        }
        cookies.set('custom_nodes', customNodes, {path: '/', expires: fiveYearsFromNow})
        alert('Node has been removed successfully.')
        this.forceUpdate();
    }

    handleCancelFrontRun = () => {
        clearIntervalAsync(this.liquidityInterval);
        const {frontRun} = this.state;
        this.setState({
            frontRun: !frontRun,
            isLoading: false,
        })
    }

    handlePaste = (e) => {
        e.preventDefault();
        navigator.clipboard.readText().then(async clipText => {
            const text = document.getElementById("tokenAddress").innerText = clipText
            e.target.name = 'tokenAddress';
            e.target.value = text;
            await this.handleOnchange(e);
        })
    }

    handleChainSwitch = (e) => {
        const {value} = e.target;
        const provider = getProviderUrl(value);
        this.setState({
            selectedChain: value,
            tokenAddress: '',
            defaultProvider: provider,
        })
        if (this.coinInterval) clearIntervalAsync(this.coinInterval)
    }

    handleTokenSelect = (e) => {
        const {name, value} = e.target;
        this.setState({
            [name]: value
        })
    }

    handleHoneypotFlag = () => {
        const {checkForHoneypot} = this.state;
        this.setState({
            checkForHoneypot: !checkForHoneypot,
        })
    }

    handleSaveConfiguration = () => {
        const configurationCookies = new Cookies();
        let fiveYearsFromNow = new Date();
        const {
            bnbAmountToSnipe,
            buyTimes,
            slippage,
            maxGas,
            gwei,
            autoSnipe,
            frontrun,
            checkForHoneypot
        } = this.state;
        const customConfig = {
            bnbAmountToSnipe,
            buyTimes,
            slippage,
            maxGas,
            gwei,
            autoSnipe,
            frontrun,
            checkForHoneypot,
        }
        fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
        configurationCookies.set('custom_configuration', customConfig, {path: '/', expires: fiveYearsFromNow})
        alert('Configuration Saved.');
    }

    restoreDefaultConfig = () => {
        const cookies = new Cookies();
        cookies.set('custom_configuration', {});
        window.location.reload(false);
    }

    handleTradingDisabled = (e) => {
        const {name} = e.target;
        if (name === 'no') {
            this.setState({
                tradingDisabled: false,
                selectedAbiFunction: '',
            })
        }
        if (name === 'yes') {
            this.setState({
                tradingDisabled: true,
                frontrun: false,
            })
            this.handleFetchAbi()
        }
    }

    setSelectedAbiFunction = (e) => {
        const { value } = e.target;
        this.setState({
            selectedAbiFunction: value,
        })
    }

    handleAddApiKey = async () => {
        const apikey = prompt('Please enter your bscscan api key')
        const cookies = new Cookies();
        let fiveYearsFromNow = new Date();
        fiveYearsFromNow.setFullYear(fiveYearsFromNow.getFullYear() + 5);
        if(await verifyBscApiKey(apikey)){
            cookies.set('bsc_api', apikey, {path: '/', expires: fiveYearsFromNow});
            alert('API key added successfully.');
        } else {
            alert('Incorrect api key detected. Please double check your key.')
        }
    }

    handleFetchAbi = async () => {
        const { tokenAddress } = this.state;
        const cookies = new Cookies();
        const apikey = cookies.get('bsc_api');
        if (!cookies.get('bsc_api')) {
            alert('You need to add a bscscan api key to use this feature.\nPlease contact the developer for more info.');
            this.setState({
                tradingDisabled: false,
            })
            return;
        }
        if(!tokenAddress){
            alert('Please enter a token address to track functions');
            this.setState({
                tradingDisabled: false,
            })
        }
        const url = `https://api.bscscan.com/api?module=contract&action=getabi&address=${tokenAddress}&apikey=${apikey}`
        const abi = await fetch(url).then(res => res.json()).catch(e => alert('an error occured fetching abi functions'));
        const parsedAbiFunctions = parseAbi(abi.result);
        this.setState({
            abiFunctions: parsedAbiFunctions,
        })
    }

    handleCancelTradingDisabledCheck = () => {
        if(this.tradingDisabledInterval) clearIntervalAsync(this.tradingDisabledInterval);
        this.setState({
            isLoading: false,
        })
    }

    render() {
        const {
            isLoading,
            canSubmit,
            tokenInfo,
            tokenSymbol,
            tokenAddress,
            receipt,
            reasonForFailure,
            snipe,
            bnbAmountToSnipe,
            slippage,
            maxGas,
            gwei,
            selectedOption,
            incorrectCa,
            selectedSellOption,
            autoSnipe,
            frontRun,
            selectedChain,
            chains,
            walletBalance,
            buyTimes,
            showSnipeSuccess,
            successAmt,
            failAmt,
            tokenOptions,
            checkForHoneypot,
            tokenIsHoneypot,
            defaultProvider,
            sellTimes,
            blockDelay,
            tradingDisabled,
            abiFunctions,
            selectedAbiFunction,
        } = this.state;

        const providerUrl = getProviderUrl(selectedChain);
        const cookies = new Cookies();
        const customNodes = cookies.get('custom_nodes') || [];
        const symbol = getSymbolFromChain(selectedChain);
        const {account} = getAccount(selectedChain);
        const walletAddress = account.address;
        const bscAddressUri = 'https://bscscan.com/address/';
        const uniswapAddressUri = 'https://etherscan.io/address/';
        const recentTransactions = selectedChain === bsc ? bscAddressUri + walletAddress : uniswapAddressUri + walletAddress;
        return (
            <div className="formWrapper">
                <div className="container">
                    <form onSubmit={this.handleSubmit}>
                        <label className={"label"}>
                            Chain
                        </label>
                        <div style={{marginTop: '12px'}}>
                            <select name="rpcProviders" id="rpcProviders"
                                    onChange={this.handleChainSwitch} style={{
                                padding: '5px',
                                borderRadius: '15px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                width: '175px',
                                marginBottom: '20px',
                            }}>
                                {chains.length > 0 && chains.map((chain, idx) => {
                                    return <option key={idx}>{chain}</option>
                                })}
                            </select>
                        </div>
                        {selectedOption === 'buy' &&
                        <div style={{marginBottom: '20px'}}>
                            <div className="inputWrapper" style={{display: 'inline-block'}}>
                                <label className="labelCustom" style={{marginRight: '0px'}}>
                                    <span>Amount </span>
                                </label>
                                <br/>
                                <input className="inputCustom" required placeholder="0.01" name="bnbAmountToSnipe"
                                       value={bnbAmountToSnipe} onChange={this.handleOnchange}
                                       style={{
                                           textAlign: 'center',
                                           width: '75px',
                                           clear: 'both'
                                       }}/>
                            </div>
                            <div className="inputWrapper" style={{display: 'inline-block'}}>
                                <label className="labelCustom" style={{marginLeft: '0px'}}>
                                    <span>Buy Times</span>
                                </label>
                                <br/>
                                <input className="inputCustom" required placeholder="0.01" name="buyTimes"
                                       value={buyTimes} onChange={this.handleOnchange}
                                       style={{
                                           textAlign: 'center',
                                           width: '75px',
                                           clear: 'both'
                                       }}/>
                            </div>
                            {selectedChain === bsc &&
                            <div className="inputWrapper" style={{display: 'inline-block'}}>
                                <select name="selectedToken" id="selectedToken"
                                        onChange={this.handleTokenSelect} style={{
                                    textAlign: 'center',
                                    width: '90px',
                                    padding: '10px',
                                    borderRadius: '5px',
                                    backgroundColor: 'white',
                                    clear: 'both'
                                }}>
                                    {tokenOptions.map((option) => {
                                        return <option>{option.toUpperCase()}</option>
                                    })}
                                </select>
                            </div>}
                        </div>
                        }
                        <div className="inputWrapper">
                            <label className="label">
                                <span>Max Slippage </span>
                                <FontAwesomeIcon icon={faInfoCircle} onClick={handleSlippageInfo}/>
                            </label>
                            <br/>
                            <input className="input" required placeholder="Slippage" name="slippage"
                                   value={slippage} onChange={this.handleOnchange} type={"number"}/>
                        </div>
                        <div className="inputWrapper">
                            <label className="label">
                                <span>Max Gas </span>
                                <FontAwesomeIcon icon={faInfoCircle} name={"maxGas"} onClick={handleMaxGasInfo}/>
                            </label>
                            <br/>
                            <input className="input" required placeholder="700,000 Recommended" name="maxGas"
                                   value={maxGas} onChange={this.handleOnchange} type={"number"}/>
                        </div>
                        <div className="inputWrapper">
                            <label className="label">
                                <span>Gwei </span>
                                <FontAwesomeIcon icon={faInfoCircle} name={"gwei"} onClick={handleGweiInfo}/>
                            </label>
                            <br/>
                            <input className="input" required placeholder="The higher the better, recommended: 25+"
                                   name="gwei" value={gwei} onChange={this.handleOnchange} type={"number"}/>
                        </div>
                        <div className="inputWrapper">
                            <label className="label">
                                {`Token To ${selectedOption === 'buy' ? 'Snipe (CA)' : 'Sell (CA)'} `}
                            </label>
                            <br/>
                            <input className="input" required placeholder="Contract Address" id={"tokenAddress"}
                                   name="tokenAddress" value={tokenAddress} onChange={this.handleOnchange}
                                   style={{marginBottom: '10px'}} max={500}/> <br/>
                            <button className={"pasteButton"} onClick={this.handlePaste}>Paste from clipboard
                            </button>
                        </div>
                        <label className={"label"}>
                            Node
                        </label>
                        <FontAwesomeIcon icon={faInfoCircle} style={{color: 'white'}} name={"autosnipe"}
                                         onClick={handleNodeInfo}/>
                        <div style={{marginTop: '12px'}}>
                            <select name="rpcProviders" id="rpcProviders" value={defaultProvider}
                                    onChange={this.handleNodeChange} style={{
                                padding: '5px',
                                borderRadius: '15px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                width: '300px'
                            }}>
                                <option
                                    value={providerUrl}>{providerUrl.length > 30 ? providerUrl.slice(0, 30) + '...' : providerUrl} (public)
                                </option>
                                {customNodes.length > 0 && customNodes.map((customNode, idx) => {
                                    return <option
                                        key={idx}
                                        value={customNode}>{`${customNode.length > 35 ? customNode.slice(0, 35) + '...' : customNode}`}</option>
                                })}
                            </select>
                            <br/>
                            <p onClick={this.handleAddNode} style={{
                                marginRight: '15px',
                                display: 'inline-block',
                                fontSize: '14px',
                                color: '#5e8ce8'
                            }}>Add Custom Node
                            </p>
                            <p onClick={this.handleRemoveNode}
                               style={{display: 'inline-block', fontSize: '14px', color: '#5e8ce8'}}>Remove Custom
                                Node
                            </p>
                        </div>
                        {selectedOption === 'buy' && <div>
                            <input
                                id={"autosnipe"}
                                type="checkbox"
                                checked={autoSnipe}
                                onChange={this.handleCheckboxChange}/>
                            <label className="radiolabel" htmlFor={"autosnipe"}>
                                Snipe after CA pasted
                            </label>
                            <FontAwesomeIcon icon={faInfoCircle} style={{color: 'white'}} name={"autosnipe"}
                                             onClick={handleAutoSnipe}/><br/>
                            {!tradingDisabled && <div>
                                <input
                                    id={"frontRun"}
                                    type="checkbox"
                                    style={{marginTop: '20px'}}
                                    checked={frontRun}
                                    onChange={this.handleFrontRun}/>
                                <label className="radiolabel" htmlFor={"frontRun"}>
                                    Frontrun
                                </label>
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'white'}} name={"frontrun"}
                                                 onClick={handleFrontRunInfo}
                                />
                            </div>}
                            {selectedChain === bsc &&
                            <div style={{marginTop: '10px'}}>
                                <label>Snipe after method invoked?</label>
                                <FontAwesomeIcon icon={faInfoCircle} onClick={handleAbiMethodInfo} style={{color: "white"}}/><br />
                                <input
                                    type={'radio'}
                                    name={'yes'}
                                    value={'yes'}
                                    id={'tradingDisabledYes'}
                                    checked={tradingDisabled === true}
                                    onChange={this.handleTradingDisabled}
                                />
                                <label className="radiolabel" htmlFor={"tradingDisabledYes"}>Yes</label>
                                <input
                                    type={'radio'}
                                    name={'no'}
                                    value={'no'}
                                    checked={tradingDisabled === false}
                                    id={'tradingDisabledNo'}
                                    onChange={this.handleTradingDisabled}
                                />
                                <label className="radiolabel" htmlFor={"tradingDisabledNo"}>No</label>
                            </div>
                            }
                            {selectedChain === bsc && tradingDisabled === true &&
                            <select name="functionsDropdown" id="functionsDropdown" value={selectedAbiFunction}
                                    onChange={this.setSelectedAbiFunction} style={{
                                padding: '5px',
                                marginTop: '15px',
                                borderRadius: '15px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                width: '300px'
                            }}>
                                <option>Select A Method</option>
                                {abiFunctions.length > 0 && abiFunctions.map((abiFunction, idx) => {
                                    return <option
                                        key={idx}
                                        value={abiFunction}>{`${idx+1}. `}{abiFunction}</option>
                                })}
                            </select>
                            }
                            {selectedChain === bsc && <div>
                                <input
                                    id={"checkForHoneypot"}
                                    type="checkbox"
                                    style={{marginTop: '20px'}}
                                    checked={checkForHoneypot}
                                    onChange={this.handleHoneypotFlag}/>
                                <label className="radiolabel" htmlFor={"checkForHoneypot"}>
                                    Check For Honeypot
                                </label>
                                <FontAwesomeIcon icon={faInfoCircle} style={{color: 'white'}}
                                                 name={"checkForHoneypot"}
                                                 onClick={handleHoneypotCheckedInfo}
                                />
                            </div>}
                        </div>}
                        {selectedOption === 'buy' && <div>
                            <label>Block Delay</label>
                            <input onChange={this.handleOnchange} value={blockDelay} name='blockDelay' style={{
                                width: '35px',
                                textAlign: 'center',
                                marginTop: '15px',
                                marginRight: '10px'
                            }}/>
                            <FontAwesomeIcon icon={faInfoCircle} style={{color: 'white'}}
                                             name={"checkForHoneypot"}
                                             onClick={handleBlockDelayInfo}
                            />
                        </div>
                        }
                        {incorrectCa && <p style={{color: 'red'}}>Please double check the CA you entered</p>}
                        <div>
                            <input
                                type="radio"
                                value="buy"
                                name="buy"
                                checked={selectedOption === 'buy'}
                                onChange={this.onChangeValue}
                                id={"radioBuyButton"}
                                style={{marginTop: '20px', marginBottom: '15px'}}
                            /> <label className="radiolabel" htmlFor={"radioBuyButton"}>Buy</label>
                            <input
                                type="radio"
                                value="sell"
                                name="sell"
                                checked={selectedOption === 'sell'}
                                id={"radioSellButton"}
                                onChange={this.onChangeValue}
                                style={{marginTop: '20px', marginBottom: '15px'}}
                            /> <label className="radiolabel" htmlFor={"radioSellButton"}>Sell</label>
                        </div>
                    </form>
                    {selectedOption === 'buy' ?
                        !isLoading && <div>
                            <button className={"submitButton"}
                                    onClick={this.handleSubmit}
                            >
                                <FontAwesomeIcon icon={faCrosshairs}
                                                 style={{color: 'black', marginRight: '15px'}}/>
                                {frontRun ? 'Front Run' : 'Snipe Token'}
                            </button>
                        </div>
                        : !isLoading && selectedOption === 'sell' &&
                        <div>
                            {tokenAddress && tokenInfo && tokenInfo.balances && tokenInfo.balances.tokenBalance > 0 ?
                                <div>
                                    <div>
                                        <input
                                            type="radio"
                                            value="25"
                                            name="25"
                                            checked={selectedSellOption === '25'}
                                            onChange={this.onChangeValue}
                                            id={"radioSellButton25"}
                                            style={{marginTop: '20px', marginBottom: '15px'}}
                                        /> <label className="radiolabel" htmlFor={"radioSellButton25"}>25%</label>
                                        <input
                                            type="radio"
                                            value="50"
                                            name="50"
                                            checked={selectedSellOption === '50'}
                                            onChange={this.onChangeValue}
                                            id={"radioSellButton50"}
                                            style={{marginTop: '20px', marginBottom: '15px'}}
                                        /> <label className="radiolabel"
                                                  htmlFor={"radioSellButton50"}>50%</label>
                                        <input
                                            type="radio"
                                            value="75"
                                            name="75"
                                            checked={selectedSellOption === '75'}
                                            onChange={this.onChangeValue}
                                            id={"radioSellButton75"}
                                            style={{marginTop: '20px', marginBottom: '15px'}}
                                        /> <label className="radiolabel" htmlFor={"radioSellButton75"}>75%</label>
                                        <input
                                            type="radio"
                                            value="100"
                                            name="100"
                                            checked={selectedSellOption === '100'}
                                            onChange={this.onChangeValue}
                                            id={"radioSellButton100"}
                                            style={{marginTop: '20px', marginBottom: '15px'}}
                                        /> <label className="radiolabel" htmlFor={"radioSellButton100"}>100%</label>
                                    </div>
                                    <div className="inputWrapper">
                                        <label className="labelCustom" style={{marginLeft: '0px'}}>
                                            <span>Split Sells</span>
                                        </label>
                                        <br/>
                                        <input className="inputCustom" required name="sellTimes"
                                               value={sellTimes} onChange={this.handleOnchange}
                                               style={{
                                                   textAlign: 'center',
                                                   width: '10vw',
                                                   clear: 'both'
                                               }}/>
                                    </div>
                                    <button className={"sellButton"}
                                            onClick={this.handleSubmit}>
                                        Sell Tokens
                                    </button>
                                </div>
                                :
                                <div>
                                    {tokenInfo && tokenInfo.balances && tokenInfo.balances.tokenBalance <= 0 ?
                                        <p style={{
                                            color: '#DFAE20'
                                        }}>You don't own any {tokenInfo.name} tokens.</p> :
                                        <p style={{
                                            color: '#DFAE20'
                                        }}>Please enter a Valid token CA to sell.</p>}
                                </div>}
                        </div>
                    }
                    {showSnipeSuccess && successAmt > 0 &&
                    <p style={{color: 'green', fontWeight: '700'}}>Sniped {successAmt} time(s) successfully!</p>}
                    {tokenIsHoneypot &&
                    <p style={{color: 'red', fontWeight: '700'}}> Snipe Reverted. Token is a honeypot.</p>}
                    <DisplayData
                        isLoading={isLoading}
                        canSubmit={canSubmit}
                        tokenInfo={tokenInfo}
                        frontRun={frontRun}
                        tokenSymbol={tokenSymbol}
                        tokenAddress={tokenAddress}
                        receipt={receipt}
                        reasonForFailure={reasonForFailure}
                        snipe={snipe}
                        selectedOption={selectedOption}
                        selectedChain={selectedChain}
                        symbol={symbol}
                        failAmt={failAmt}
                    />
                    {frontRun && isLoading && selectedOption === 'buy' &&
                    <div>
                        <button className={"sellButton"} style={{fontSize: '14px !important'}}
                                onClick={this.handleCancelFrontRun}
                        >
                            Cancel
                        </button>
                    </div>
                    }
                    {selectedChain === bsc && tradingDisabled === true && isLoading && selectedOption === 'buy' &&
                    <button className={"sellButton"} style={{fontSize: '14px !important'}}
                            onClick={this.handleCancelTradingDisabledCheck}
                    >
                        Cancel
                    </button>
                    }
                    {walletBalance && <p style={{color: '#DFAE20'}}>{`${symbol} `}
                        Balance: {tokenInfo && tokenInfo.balances && tokenInfo.balances.bnbBalance ?
                            Number(tokenInfo.balances.bnbBalance).toFixed(4) : Number(walletBalance).toFixed(4)}</p>}
                    <a href={recentTransactions} target={"_blank"} rel="noreferrer" style={{
                        textDecoration: 'none'
                    }}>
                        <p style={{color: '#5e8ce8',}}>Recent Transactions</p>
                    </a>
                    <div style={{color: '#5e8ce8', cursor: 'pointer'}} onClick={this.handleSaveConfiguration}>Save
                        Configuration
                    </div>
                    <br/>
                    <div style={{color: '#5e8ce8', cursor: 'pointer'}} onClick={this.restoreDefaultConfig}>Restore
                        Default Configuration
                    </div><br/>
                    <div style={{color: '#5e8ce8', cursor: 'pointer'}} onClick={this.handleAddApiKey}>
                        Add bscscan api key
                    </div>
                    <br/>
                </div>
            </div>
        )
    }
}

export default SniperForm;